import sha256 from 'crypto-js/sha256';
import KNB from '@wmfe/mach-pro-knb';
import { EnumLang } from './constant';
import { DEFAULT_CITY_ID } from '../contant';

export interface IApiExceptionExtraInfo {
  data?: any;
  code: string | number;
  message?: string;
  response?: {
    status?: number;
    data?: any;
  };
}

interface IConfig {
  // 错误参数
  params?: any;
  // 错误链接
  url?: string;
  // 错误配置：为 false 直接上报
  combo?: boolean;
  // 错误等级
  level?: 'info' | 'debug' | 'warn' | 'error';
  // 错误类型
  category?: 'jsError' | 'ajaxError' | 'resourceError';
}

export class ApiException extends Error {
  instance?: IApiExceptionExtraInfo;

  config?: IConfig;

  errMsg?: string;

  code?: number;

  constructor(name?: string, error?: IApiExceptionExtraInfo | ApiException, config?: IConfig) {
    super(name);
    const { code, errMsg, instance } = this.adapt(error);
    this.errMsg = errMsg;
    this.code = code;
    this.instance = instance;
    this.config = config;
  }

  /**
   * 避免 ApiException 重复设置
   * @param error 错误对象
   * @returns 适配对象
   */
  adapt(error?: IApiExceptionExtraInfo | ApiException): {
    code?: number;
    errMsg?: string;
    instance?: IApiExceptionExtraInfo;
  } {
    if (error && error instanceof ApiException) {
      const { code, errMsg, instance } = error || {};
      return { code, errMsg, instance };
    }
    const { code, errMsg } = error?.response?.data || error?.data || {};
    return { code, errMsg, instance: error };
  }
}

/**
 * 数据加密
 */
export function encryptionData(data: string): {
  sign: string;
  submitCode: string;
} {
  const submitCode = ((Math.random() + 1) * new Date().getTime()).toFixed(0);
  const sign = sha256(`${data}&${submitCode}`).toString();
  return {
    submitCode,
    sign,
  };
}

// 更新数据
export function setVisitInfo(data: any) {
  // console.log('globalThis.customerGlobalState', globalThis.customerGlobalState);

  const { visitInfo } = globalThis.customerGlobalState || {};
  globalThis.customerGlobalState.visitInfo = {
    ...visitInfo,
    ...data,
  };
}

// 二级页面 MachPro 改造有使用
// 更新数据

// 客服留言重复工单分流
export const dialogHandle = (
  getText: (key: string, defaultText: string) => string,
  goToOrderformHandle: (caseId: string | undefined) => void,
  onBackClick: () => void,
  caseId?: string
) => {
  // Dialog.confirm({
  //   message: workOrderSubmittedCheckDialogContent(
  //     getText(
  //       "cs_portal_repeat_case_guide",
  //       "There is a pending work order currently, it cannot be resubmitted. Please modify it and resubmit."
  //     )
  //   ),
  //   allowHtml: true,
  //   cancelButtonText: getText("cs_portal_quit", "Exit"),
  //   confirmButtonText: getText("cs_portal_revise", "Modify"),
  // })
  //   .then(() => {
  //     console.log("dialog confirm");
  //     goToOrderformHandle(caseId);
  //   })
  //   .catch(() => {
  //     console.log("dialog cancel");
  //     onBackClick();
  //   });
};

// let filterXSS: FilterXSS;

export function filterText(text: string, filterSymbol = true): string {
  if (!text) {
    return '';
  }

  // if (!filterXSS) {
  //   filterXSS = new FilterXSS({
  //     whiteList: {
  //       div: ["class", "style"],
  //       p: ["style"],
  //       span: ["style"],
  //       strong: [],
  //       strike: [],
  //       u: [],
  //       em: [],
  //       ol: [],
  //       ul: [],
  //       li: [],
  //       h1: [],
  //       h2: [],
  //       h3: [],
  //       h4: [],
  //       h5: [],
  //       blockquote: [],
  //       pre: [],
  //       a: ["href", "target"],
  //       img: ["src", "alt"],
  //       br: [],
  //       table: ["class", "style"],
  //       tbody: [],
  //       tr: [],
  //       td: ["colspan", "rowspan", "width", "style"],
  //     },
  //   });
  // }

  const newText = text;
  if (filterSymbol) {
    // newText = filterXSS.process(newText);
  }
  return newText;
}

// 根据 locale 获取 answer 里面的 content，如果取不到，用英语兜底
export const getAnswerContentByLocale = (displayContent: any[], locale: string) => {
  let target = displayContent.find((content: any) => content?.language === locale);
  // 如果没有匹配到内容，且不是英文，默认查询下英文兜底
  if (!target && locale !== EnumLang.En) {
    target = displayContent.find((content: any) => content?.language === EnumLang.En);
  }
  return target || { content: '' };
};

// 时间本地化--利用i18nSDK 将后端时间戳转成时间字符串
export const formatDateTimeByCityId = (cityId: string | number, timestamp: number, locale: string) => {
  try {
    if (!timestamp) {
      return '';
    }
    const SLMPI18N = Mach.requireModule('Intl');
    const res = SLMPI18N?.formatDateTimeByCityId({
      // 合同时间治理
      cityId: String(cityId || DEFAULT_CITY_ID),
      timestamp,
      dateStyle: 1,
      timeStyle: 1,
      // pattern: DATE_TIME_PATTERN?.[locale] || DATE_TIME_PATTERN.default,
    });

    return res;
  } catch (error) {
    return timestamp;
  }
};

// 登录
export const gotoLogin = (cb?) => {
  KNB
    && KNB?.login({
      success() {
        cb && cb();
      },
      fail() {
      },
    });
};

// 判断是否需要登录
export const checkNeedLogin = (cb?) => {
  const Login = Mach.requireModule('Login');
  const isLogin = Login?.isLogin?.();
  if (isLogin) {
    cb && cb();
    return false;
  }

  gotoLogin(cb);
  return true;
};
